import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  TextField,
  Box,
  Button,
  Drawer,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import Header from "../../component/Header";
import {
  updateDetailsAction,
  fetchDetailAction,
  resetState,
} from "../../state/translation/translationSlice"; // Update import statements
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import Loader from "../../component/loader";

const EditExtras = ({ open, handleClose, id }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.translation.loading);
  const translation = useSelector((state) => state.translation.data);
  const isSuccess = useSelector((state) => state?.translation.isSuccess);
  const Updated = useSelector((state) => state?.translation.Updated);
  const appErr = useSelector((state) => state.translation.appErr);

  useEffect(() => {
    if (id) {
      dispatch(fetchDetailAction(id));
    }
  }, [dispatch, id, isSuccess]);
  useEffect(() => {
    if (isSuccess && Updated) {
      toast.success("Details Edited Successfully!");
   
    }
  }, [isSuccess, Updated]);

  useEffect(() => {
    if (appErr) {
      toast.error(appErr);
    }
  }, [appErr]);

  // Define validation schema
  const validationSchema = Yup.object().shape({
    label: Yup.string().required("Label is required"),
    shortcut: Yup.string().required("Shortcut is required"),
    translatedWord: Yup.string().required(" Translated Word is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
        label: translation?.label || "", // Ensure that the initial value is not undefined
        shortcut: translation?.shortcut || "",
        translatedWord: translation?.translatedWord || "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      const data = {
        label: values?.label.toLowerCase(),
        shortcut: values?.shortcut,
        translatedWord: values?.translatedWord.toLowerCase(),
      };
      dispatch(updateDetailsAction({ data, id }));
      console.log(values);
      handleClose();
      setSubmitting(false);
      setTimeout(() => {
        dispatch(resetState());
      }, 3000);
    },
  });

  return (
    <React.Fragment>
      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: "40%", // Default width
            "@media (max-width: 700px)": {
              width: "70%", // Width set to 70% for screens <= 700px
            },
          },
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <Box m="1.5rem 2.5rem">
            <Box mb="2rem">
              <Header title="Translation Details" subtitle="Add New Extras" />
            </Box>
            <Grid container>
              <Grid item xs={12} md={12}>
                <Box
                  p={2}
                  borderRadius={4}
                  bgcolor={theme.palette.background.default}
                  boxShadow={theme.shadows[3]}
                >
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Label :
                  </Typography>
                  <hr
                    style={{ border: "1px solid #f0f0f0", margin: "10px 0" }}
                  />
                  <Typography variant="h6" gutterBottom>
                    Label: <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    id="label"
                    name="label"
                    label="Label"
                    variant="outlined"
                    fullWidth
                    value={formik.values.label}
                    onChange={formik.handleChange}
                    error={formik.touched.label && Boolean(formik.errors.label)}
                    helperText={formik.touched.label && formik.errors.label}
                    style={{ marginTop: "25px", width: "100%" }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <Box
                  mt={3}
                  p={2}
                  mb={2}
                  borderRadius={4}
                  bgcolor={theme.palette.background.default}
                  boxShadow={theme.shadows[3]}
                >
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Language :
                  </Typography>
                  <hr
                    style={{ border: "1px solid #f0f0f0", margin: "10px 0" }}
                  />
                  <Typography variant="h6" gutterBottom>
                    Shortcut: <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                  id="shortcut"
                  name="shortcut"
                  value={formik.values.shortcut}
                  onChange={formik.handleChange}
                  variant="outlined"
                  fullWidth
                  error={formik.touched.shortcut && Boolean(formik.errors.shortcut)}
                  style={{ marginTop: "25px", width: "100%" }}
                >
               
                </TextField>
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <Box
                  mt={3}
                  p={2}
                  mb={2}
                  borderRadius={4}
                  bgcolor={theme.palette.background.default}
                  boxShadow={theme.shadows[3]}
                >
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Translated Word :
                  </Typography>
                  <hr
                    style={{ border: "1px solid #f0f0f0", margin: "10px 0" }}
                  />
                  <Typography variant="h6" gutterBottom>
                    Word: <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    id="translatedWord"
                    name="translatedWord"
                    label="Translated Word"
                    variant="outlined"
                    fullWidth
                    value={formik.values.translatedWord}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.translatedWord &&
                      Boolean(formik.errors.translatedWord)
                    }
                    helperText={
                      formik.touched.translatedWord &&
                      formik.errors.translatedWord
                    }
                    style={{ marginTop: "25px", width: "100%" }}
                  />
                </Box>
              </Grid>
            </Grid>

            <Button
              onClick={handleClose}
              variant="contained"
              color="secondary"
              size="small"
              style={{ marginRight: "5px" }}
            >
              Cancel
            </Button>
            <Button
            type="submit"
            variant="contained"
            color="secondary"
            disabled={loading}
            size="small"
          >
            {!loading ? "Submit" : <Loader />}
          </Button>
          </Box>
        </form>
      </Drawer>
    </React.Fragment>
  );
};

export default EditExtras;
